import { Grid as MuiGrid, styled } from '@material-ui/core';

export const GridWrapper = styled(MuiGrid)({
  marginBottom: '16px',
});
